/*
 * @Author: Liux
 * @Date: 2019-12-03 09:06:11
 * @LastEditor: Liux
 * @LastEditTime : 2019-12-23 07:21:15
 */
import { Injectable, EventEmitter } from '@angular/core';
import { AdDateRangeModel } from '../common/ad-date-range-model';

@Injectable()
export class AdDateRangeEventService {
  public dateClick: EventEmitter<any> = new EventEmitter<any>();

  public toolClick: EventEmitter<any> = new EventEmitter<any>();

  public dateRangeClick: EventEmitter<any> = new EventEmitter<any>();
  public rangeValueChange: EventEmitter<AdDateRangeModel> = new EventEmitter<
    AdDateRangeModel
  >();

  public close: EventEmitter<any> = new EventEmitter<any>();


  public updatePosition: EventEmitter<any> = new EventEmitter<any>();

  public rangeValueChangeByOutside: EventEmitter<AdDateRangeModel> = new EventEmitter<
    AdDateRangeModel
  >();
}
